module.exports = __webpack_public_path__ + "eddd6624a01d34d70b2ae51eb4738a1c.png";